import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { faFacebook, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import { environment } from 'src/environments/environment';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Input() lang!: string;
  faFacebook = faFacebook;
  faWhatsapp = faWhatsapp;
  faLinkedin = faLinkedin;

  logoPath = `../../../assets/${environment.projectName}/media/header/logo.png`;

  languages: any[] = [];
  selectedLanguage: any;
  tabs: any[] = [];
  isScrolled = false;
  isMenuOpen = false;
  userInfo: any;
  isHome: boolean = false;


  @ViewChild('header') header!: ElementRef;
  @ViewChild('navbar') navbar!: ElementRef;


  constructor(
    private router: Router,
    private translate: TranslateService,
    private fetchDataService: FetchDataService,
    private userInfoService: UserInfoService,
    private renderer: Renderer2
  ) {
    this.userInfo = this.userInfoService.getUserInfo();
    this.loadHeaderData();
  }
  ngOnInit(): void {
    this.checkRoute();
  }
checkRoute(): void {
  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      // only match root home, not "home-page"
      this.isHome =
        event.urlAfterRedirects === "/" ||
        /^\/(en|ar|de)\/home$/.test(event.urlAfterRedirects);

      if (this.isHome) {
        this.renderer.removeClass(this.navbar.nativeElement, "scrolled");
      } else {
        this.renderer.addClass(this.navbar.nativeElement, "scrolled");
      }
    }
  });
}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isHome) return;
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    if (scrollY > 50) {
      this.renderer.addClass(this.navbar.nativeElement, 'scrolled')
    } else {
      this.renderer.removeClass(this.navbar.nativeElement, 'scrolled')
    }
  }

  isChildActive(tab: any): boolean {
    if (!tab.children) return false;
    return tab.children.some((child: any) => this.router.url.includes
      (child.route))
  }
  loadHeaderData(): void {
    this.fetchDataService.getJSONheader().subscribe({
      next: (data: any) => {
        this.tabs = this.filterTabs(data?.tabs || []);
        this.languages = data?.languages || [];
        this.selectLanguage(this.lang);
      },
      error: (err) => {
        console.error('Error fetching header data:', err);
      },
    });
  }

  filterTabs(tabs: any[]): any[] {
    if (!this.userInfo.accessToken || !this.userInfo.userId) {
      return tabs.filter(tab => tab.name !== 'header_profile');
    }
    return tabs.filter(tab => tab.name !== 'header_login');
  }

  selectLanguage(lang: string): void {
    this.selectedLanguage = this.languages.find(l => l.value === lang);
    this.translate.setDefaultLang(lang);
    this.closeNavbar();
  }

  toggleNavbar(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeNavbar(): void {
    this.isMenuOpen = false;
  }

  getNewURL(lang: string): string {
    return this.router.url.replace(/\/[a-z]{2}(\/|$)/, `/${lang}$1`);
  }

  isActive(tab: any): boolean {
    return this.router.url.includes(tab.route);
  }
}
